import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../../../components/SectionFormContainer'
import GroomingAppointmentWizardContext from '../GroomingAppointmentWizardContext'
import MultilineTextField from '../../../../TextEntry/MultilineTextField'

const DescriptionEntry = (props) => {
	const {
		wizardContextProvider: { grooming_appointment, setWizardAttributeAndValues }
	} = useContext(GroomingAppointmentWizardContext)
	const { visit_attr, title = '', subtext = '' } = props

	const handleTextEntry = useCallback(
		(e) => {
			const value = e.target.value
			const newValues = { ...grooming_appointment }
			newValues[visit_attr] = value
			setWizardAttributeAndValues(newValues)
		},
		[grooming_appointment, setWizardAttributeAndValues, visit_attr]
	)

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<MultilineTextField
				minRows={8}
				label="Type answer here..."
				variant="outlined"
				value={grooming_appointment[visit_attr]}
				onChange={handleTextEntry}
			/>
		</SectionFormContainer>
	)
}

export default DescriptionEntry
